import { Link } from "react-router-dom";
import { EnvelopeSimple, Phone, WhatsappLogo, Globe, InstagramLogo, TiktokLogo, YoutubeLogo, Newspaper } from "@phosphor-icons/react";
import { BRAND, NAV, LOGO_WORDMARK } from "../data/content";
import { useSettings } from "../hooks/usePublicContent";

export const Footer = () => {
  const s = useSettings();
  return (
  <footer data-testid="main-footer" className="border-t border-white/5 bg-[#0b0b0d]">
    <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-3 gap-12">
      <div>
        <div className="flex items-center gap-3">
          <img src={LOGO_WORDMARK} alt="BarManProf" className="h-11 object-contain" />
        </div>
        <p className="mt-4 text-[#A1A1AA] text-sm leading-relaxed max-w-xs">
          {s.tagline}. Esperto del settore: docente, consulente, formatore e Open Bar Specialist.
        </p>
        <div className="mt-6 flex items-center gap-3" data-testid="footer-socials">
          {[
            [s.instagram, InstagramLogo, "Instagram"],
            [s.tiktok, TiktokLogo, "TikTok"],
            [s.youtube, YoutubeLogo, "YouTube"],
            [s.substack, Newspaper, "Substack"],
          ].filter(([url]) => url).map(([url, Icon, label]) => (
            <a key={label} href={url} target="_blank" rel="noreferrer" aria-label={label} data-testid={`social-${label.toLowerCase()}`}
               className="w-10 h-10 rounded-full bg-[#111113] border border-white/10 flex items-center justify-center text-[#A1A1AA] hover:text-[#D97736] hover:border-[#D97736]/50 transition-colors">
              <Icon size={20} />
            </a>
          ))}
        </div>
      </div>

      <div>
        <h4 className="text-sm tracking-[0.2em] uppercase text-[#D97736] font-semibold mb-5">Naviga</h4>
        <ul className="space-y-3">
          {NAV.map((n) => (
            <li key={n.to}>
              <Link to={n.to} className="text-[#A1A1AA] text-sm hover:text-[#D97736] transition-colors">
                {n.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <h4 className="text-sm tracking-[0.2em] uppercase text-[#D97736] font-semibold mb-5">Contatti</h4>
        <ul className="space-y-3 text-sm">
          <li>
            <a href={`mailto:${s.email}`} data-testid="footer-email" className="flex items-center gap-3 text-[#A1A1AA] hover:text-[#D97736] transition-colors">
              <EnvelopeSimple size={18} /> {s.email}
            </a>
          </li>
          <li>
            <a href={`tel:${s.phone.replace(/\s/g, "")}`} data-testid="footer-phone" className="flex items-center gap-3 text-[#A1A1AA] hover:text-[#D97736] transition-colors">
              <Phone size={18} /> {s.phone}
            </a>
          </li>
          <li>
            <a href={`https://wa.me/${s.whatsapp}`} target="_blank" rel="noreferrer" data-testid="footer-whatsapp" className="flex items-center gap-3 text-[#A1A1AA] hover:text-[#25D366] transition-colors">
              <WhatsappLogo size={18} /> Scrivimi su WhatsApp
            </a>
          </li>
          <li>
            <a href={s.websiteUrl} target="_blank" rel="noreferrer" data-testid="footer-website" className="flex items-center gap-3 text-[#A1A1AA] hover:text-[#D97736] transition-colors">
              <Globe size={18} /> {s.website}
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6 flex flex-col sm:flex-row justify-between gap-2 text-xs text-[#71717A]">
        <span>© {new Date().getFullYear()} BarManProf. Tutti i diritti riservati.</span>
        <span>Consulenza · Formazione · Eventi Open Bar</span>
      </div>
    </div>
  </footer>
  );
};
